import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUnreadCount } from "../../../store/actions/in-app-notification";

const POLLING_INTERVAL = 45_000; // 45 seconds

const useUnreadCountPolling = (isAuthenticated: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) return;

    // Fetch immediately on mount
    dispatch(getUnreadCount());

    const intervalId = setInterval(() => {
      dispatch(getUnreadCount());
    }, POLLING_INTERVAL);

    return () => clearInterval(intervalId);
  }, [isAuthenticated, dispatch]);
};

export default useUnreadCountPolling;
